export default "__VITE_ASSET__dc29396c__"